var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"slider"}},[_c('ul',{ref:"silderCont",staticClass:"slider__text-cont",style:({
      height: (_vm.windowH + "px"),
      transform: ("rotate(" + (_vm.rotation.val) + "deg) translate3d(0, 0, " + _vm.scale + "px)")
    })},_vm._l((_vm.texts),function(text){return _c('li',{key:text.title,staticClass:"slider__item",style:({
        top: ((text.top) + "px"),
        left: ((text.left) + "px"),
        transform: ("translate3d(" + _vm.scrollValue + "px, 0, 0)")
      }),on:{"click":_vm.clickVoice}},[_c('router-link',{style:({
          paddingRight: (_vm.paddingRight + "px"),
        }),attrs:{"to":text.id,"data-hover":text.title,"data-state":text.state,"data-mouse":"","data-mouse-attractionState":"disactive","data-hover-type":"fadeout"}},[_vm._v("\n        "+_vm._s(text.title)+"\n      ")])],1)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e07ac76","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SliderTest.vue
// module id = 355
// module chunks = 3